import {gsap} from 'gsap';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.features-scroll' ).each( function( key, component ) {
        const $panels = $( '.features-scroll__panel' );

        let topOffset = $( '.navbar' ).outerHeight();
        const fake = $( this ).find( '.features-scroll__fake' )[0];
        const count = $panels.length;
        let lastIndex = -1;
        const panelHeight = $( component ).find( '.features-scroll__panel' ).outerHeight();
        const pinnedAmount = panelHeight * count;

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).outerHeight();
        }

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: $( component ).find( '.features-scroll__desktop' )[0],
            pin: true,
            start: 'top ' + topOffset,
            end: '+=' + pinnedAmount,
            onUpdate: function( e ) {
              let index = Math.floor( e.progress * count );
              if ( index >= count ) index = count - 1;

              if ( index === lastIndex ) return;

              $panels.removeClass( 'is-active' );
              $panels.find( '*' ).attr( 'tabindex', '-1' );
              $panels.eq( index ).addClass( 'is-active' );
              $panels.eq( index ).find( '*' ).removeAttr( 'tabindex' );
              lastIndex = index;
              $( component ).find( '.features-scroll__pagination button:not(:nth-child(' + ( index + 1 ) + '))' ).removeClass( 'is-active' );
              $( component ).find( '.features-scroll__pagination button:nth-child(' + ( index + 1 ) + ')' ).addClass( 'is-active' );
            },
            scrub: 2,
          },
        } );

        let totalDelay = 0;
        $( component ).find( '.features-scroll__image' ).each( function( key, image ) {
          const previousImage = $( image ).prev()[0];
          if ( window.hasMotion ) {
            pinner.to( previousImage, {y: '-5%', ease: 'linear', delay: ( key * 0.5 ), duration: 0.4}, 0 );
            pinner.to( image, {clipPath: 'inset(0% 0% 0% 0%)', scale: '1', ease: 'linear', delay: ( key * 0.5 ), duration: 0.4}, 0 );
          } else {
            $( image ).css( {
              'clip-path': 'inset( 0% 0% 0% 0% )',
              'z-index': key,
            } );
            $( image ).addClass( 'opacity-0' );
            pinner.to( image, {opacity: 1, ease: 'linear', delay: ( key * 0.5 ), duration: 0.4}, 0 );
          }
          totalDelay += 0.5;
        } );

        pinner.to( fake, {opacity: 0, ease: 'linear', delay: ( totalDelay ), duration: 0.1}, 0 );

        $( component ).find( '.features-scroll__pagination button' ).on( 'click', function() {
          const index = $( this ).index();

          if ( index === 0 ) {
            $( 'html, body' ).animate( {
              scrollTop: $( component ).offset().top,
            }, 1000 );
          } else if ( index === ( count - 1 ) ) {
            $( 'html, body' ).animate( {
              scrollTop: $( component ).offset().top + $( component ).outerHeight() - ( panelHeight + topOffset ),
            }, 1000 );
          } else {
            $( 'html, body' ).animate( {
              scrollTop: $( component ).offset().top + ( ( panelHeight * 0.82 ) * ( ( index + 1 ) ) ),
            }, 1000 );
          }

          setTimeout( function() {
            $( component ).find( '.features-scroll__panel--' + ( index ) ).attr( 'tabindex', '0' ).trigger( 'focus' ).removeAttr( 'tabindex' );
          }, 1000 );
        } );
      } );

      $( '.features-scroll__mobile' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--features-scroll' )[0], {
          pagination: true,
          arrows: false,
          perPage: 1,
          perMove: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'features-scroll', COMPONENT );
} )( app );
